import { render, staticRenderFns } from "./GeneralEntrance.vue?vue&type=template&id=f5ff6144&scoped=true"
import script from "./GeneralEntrance.vue?vue&type=script&lang=js"
export * from "./GeneralEntrance.vue?vue&type=script&lang=js"
import style0 from "./GeneralEntrance.vue?vue&type=style&index=0&id=f5ff6144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ff6144",
  null
  
)

export default component.exports